module.exports = __webpack_public_path__ + "static/media/spicy-mama-hero-desktop-roc.081d464d.jpg";